import React, { useContext } from 'react';
import { GlobalFiltersContext } from '../../GlobalFiltersContext';
import { TimedFetch } from './use-cases/TimedFetch';

export const AuthorFilter = ({}) => {
  const {
    loadingGlobal,
    authorVisible,
    authorSearchValue,
    authorLoading,
    authorLoaded,
    authorError,
    authorData,
    authorRI,
    setAuthorVisible,
    setAuthorSearchValue,
    setAuthorLoading,
    setAuthorLoaded,
    setAuthorError,
    setAuthorData,
    setAuthorRI,
    updateData,
    setPage
  } = useContext(GlobalFiltersContext);

  return (
    <TimedFetch
      segment="author"
      placeholder="Autores"
      loadingGlobal={loadingGlobal}
      visible={authorVisible}
      searchValue={authorSearchValue}
      loading={authorLoading}
      loaded={authorLoaded}
      error={authorError}
      data={authorData}
      ri={authorRI}
      setVisible={setAuthorVisible}
      setSearchValue={setAuthorSearchValue}
      setLoading={setAuthorLoading}
      setLoaded={setAuthorLoaded}
      setError={setAuthorError}
      setData={setAuthorData}
      setRI={setAuthorRI}
      updateData={updateData}
      setPage={setPage}
      fetchOnMount={false}
    />
  );
};
